import React, { useState } from 'react';
import { clsb } from 'js/utils/classNames.util';
import { useTranslations } from 'js/hooks/i18n';
import { Button } from 'js/components/common/Button';
import { useFormatter } from 'js/hooks/useFormatter';

import { useAcceptPlayerLimits, useDeclinePlayerLimits } from './hooks';

import style from './PendingLimitsItem.scss';

export const PendingLimitsItem = ({ limit, limitType, classNames = {}, setConfirmError }) => {
    const formatter = useFormatter();
    const [isLoading, setIsLoading] = useState();
    const t = useTranslations('playtech.mobile.system.responsibleGaming.limits.');
    const { date, text, timePeriod, acceptanceNeeded } = limit;
    const allowActions = acceptanceNeeded === 0 || acceptanceNeeded === 1;
    const accept = useAcceptPlayerLimits({ timePeriod, limitType, setIsLoading, setConfirmError });
    const decline = useDeclinePlayerLimits({ timePeriod, limitType, setIsLoading, setConfirmError });

    if (!text || !date) {
        return null;
    }

    return (
        <div className={clsb([style, classNames], ['pending'])}>
            <div className={clsb([style, classNames], ['pending-info'])}>
                <span className={clsb([style, classNames], ['text'])}>{text}</span>
                <span className={clsb([style, classNames], ['date'])}>{formatter.getDateTimeShort(date)}</span>
            </div>
            {allowActions && <div className={clsb([style, classNames], ['pending-actions'])}>
                <Button
                    type="button"
                    color='negative'
                    onClick={decline}
                    disabled={isLoading}
                    className={style.btn}
                >
                    {t('decline')}
                </Button>
                <Button
                    type="button"
                    onClick={accept}
                    className={style.btn}
                    disabled={isLoading || acceptanceNeeded === 0}
                >
                    {t('accept')}
                </Button>
            </div>}
        </div>
    );
};
